import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoginPage from "./components/LoginPage";
import LayoutApp from "./components/LayoutApp";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  const [userName, setUserName] = useState(null);

  useEffect(() => {
    const updateActivity = () => {
      sessionStorage.setItem("lastActivity", Date.now());
    };

    window.addEventListener("click", updateActivity);
    window.addEventListener("keydown", updateActivity);

    return () => {
      window.removeEventListener("click", updateActivity);
      window.addEventListener("keydown", updateActivity);
    };
  }, []);


  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage onLogin={setUserName} />} />
        <Route
          path="/inicio"
          element={
            <ProtectedRoute>
              <LayoutApp userName={userName} />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;